import { render, staticRenderFns } from "./Cpi.vue?vue&type=template&id=1d45aaaa&"
import script from "./Cpi.vue?vue&type=script&lang=js&"
export * from "./Cpi.vue?vue&type=script&lang=js&"
import style0 from "./Cpi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports